import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="address"
export default class extends Controller {
  static targets = ["hiddenAddress"]

  connect() {
  }

  async showAddress() {
    try {
      const response = await fetch("/address") // Fetch from Rails endpoint
      if (!response.ok) throw new Error("Failed to fetch address")

      const data = await response.json()
      this.hiddenAddressTarget.innerHTML = data.address
      this.hiddenAddressTarget.style.display = "block"
    } catch (error) {
      console.error("Error fetching address:", error)
    }
  }
}
